import { Component } from '@angular/core';

@Component({
	selector: 'app-main-layout',
	standalone: false,
	template: `
		<div class="app-layout" [class.collapsed]="sidebarCollapsed">
			<!-- SIDEBAR COMPONENT -->
			<app-sidebar-v2 (sidebarToggled)="onSidebarToggled($event)"></app-sidebar-v2>

			<!-- MAIN CONTENT AREA -->
			<div class="main-content-container-v2">
				<!-- NAVBAR COMPONENT -->
				<app-navbar-v2></app-navbar-v2>
				<div style="padding: 2.5rem 2rem;">
					<!-- MAIN CONTENT -->
					<div>
						<router-outlet />
					</div>
				</div>
			</div>
		</div>
	`,
	styles: `
    .app-layout {
      display: grid;
      grid-template-columns: 18rem 1fr;
      height: 100vh;
      transition: grid-template-columns 0.2s ease;
    }

    .app-layout.collapsed {
      grid-template-columns: 3rem 1fr;
    }

    .main-content-container-v2 {
      display: grid; grid-template-rows: 3.75rem 1fr; height: 100vh; overflow-y: auto; background-color: #FFF;
    }

    /* Mobile responsive */
    @media (max-width: 768px) {
      .app-layout {
        grid-template-columns: 1/2fr;
      }
    }
  `,
})
export class MainLayoutComponent {
	sidebarCollapsed = false;

	onSidebarToggled(isCollapsed: boolean) {
		this.sidebarCollapsed = isCollapsed;
	}
}
